import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import OpportunityEditModal from './OpportunityEditModal';

const OpportunityEditPage: React.FC = () => {
  const { opportunityId } = useParams<{ opportunityId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const parsedOpportunityId = Number(opportunityId);
  const isIntegration = location.pathname.startsWith('/integration-opportunities');
  const returnPath = isIntegration ? '/integration-opportunities' : '/opportunities';

  if (!parsedOpportunityId) {
    return null;
  }

  return (
    <OpportunityEditModal
      opportunityId={parsedOpportunityId}
      mode="page"
      isIntegration={isIntegration}
      onClose={() => navigate(returnPath)}
      onSave={() => navigate(returnPath)}
    />
  );
};

export default OpportunityEditPage;
